module.exports = __webpack_public_path__ + "img/38.good.1cea7c5a.svg";